/*
 * @Author: Latte
 * @Date: 2022-02-18 09:34:33
 * @LAstEditors: Latte
 * @LastEditTime: 2022-02-23 16:13:50
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\system\columnManagement\index.js
 */
import request from "@/utils/request";
import config from "@/utils/config";

/**
 * 获取栏目集合
 * @param {*} params
 * @returns
 */
export function getColumnList(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/MaiColumn/ColumnList",
		params,
		method: "get",
	});
}

/**
 * 获取栏目条件
 * @param {*} params
 * @returns
 */
export function getColumnCondition(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/MaiColumn/ConditionList",
		params,
		method: "get",
	});
}

/**
 * 添加栏目
 * @param {*} data
 * @returns
 */
export function addColumn(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/MaiColumn/Add",
		data,
		method: "post",
	});
}

/**
 * 添加栏目筛选条件
 * @param {*} data
 * @returns
 */
export function addColumnCondition(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/MaiColumn/Condition/Add",
		data,
		method: "post",
	});
}

/**
 * 更新栏目
 * @param {*} data
 * @returns
 */
export function updateColumn(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/MaiColumn/Update",
		data,
		method: "PATCH",
	});
}

/**
 * 更新栏目条件
 * @param {*} data
 * @returns
 */
export function updateColumnCondition(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/MaiColumn/Condition/Update",
		data,
		method: "patch",
	});
}

/**
 * 删除栏目
 * @param {*} params
 * @returns
 */
export function deleteColumn(params) {
	return request({
		url: config.API_ADMIN + `/Api/V1/MaiColumn/Delete`,
		method: "delete",
		params
	});
}

/**
 * 删除栏目条件
 * @param {*} params
 * @returns
 */
export function deleteColumnCondition(params) {
	return request({
		url: config.API_ADMIN + `/Api/V1/MaiColumn/Condition/Delete`,
		method: "delete",
		params
	});
}

/**
 * 后台根据资源类型获取麦粒学院下子栏目集合
 * @param {Object} params
 */
export function getMaiColumnList(params) {
	return request({
		url: config.API_ADMIN + `/Api/V1/MaiColumn/Type/ColumnList`,
		method: "get",
		params
	});
}
